import { vendorAllowed, onVendorLoaded } from 'util/index';
import { trackCTAButton } from 'analytics';
import logger from 'util/logger';

/**
 * Init branch.io
 * @param {bool} noJourney - true if journey banner needs to be disabled
 */

export default function initBranch(noJourney = false) {
  if (!vendorAllowed(VENDORS.BRANCH_IO)) return;
  onVendorLoaded('branch')
    .then(() => {
      window.branch.init(process.env.REACT_APP_BRANCH_KEY, {
        no_journeys: noJourney,
      });
      window.branch.addListener('didClickJourneyCTA', (event, data) => {
        //Send Tealium event if user clicks on download button in smartbanner
        const { journey_link_data } = data || {};
        const { journey_name } = journey_link_data;
        const trackingData = {
          event_action: 'click',
          event_label: 'DOWNLOAD NU HEADER',
        };
        trackCTAButton(trackingData.event_action, trackingData.event_label, journey_name);
      });
    })
    .catch((error) => logger.error(error));
}
